import { render, staticRenderFns } from "./PageFollowers.vue?vue&type=template&id=137ab90f&"
import script from "./PageFollowers.vue?vue&type=script&lang=ts&"
export * from "./PageFollowers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports